import { DuoConfirmModal } from "./DuoConfirmModal";

export type StartDuoConfirmProps = {
  open: boolean;
  onCancel: () => void;
  onConfirm: () => void;
};

export function StartDuoConfirm({
  open,
  onCancel,
  onConfirm,
}: StartDuoConfirmProps) {
  return (
    <DuoConfirmModal
      open={open}
      title="Begin DUO-simulatie?"
      body="35 minuten zonder onderbreking, geen feedback tijdens het examen."
      onCancel={onCancel}
      onConfirm={onConfirm}
    />
  );
}
